import React from 'react'
import withTranslator from '../../HOCComponents/withTranslator'
import { Button, Icon } from '@mui/material'
import themeColors from '@layers-frontend/commons/styles/themeColors'

const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  color: themeColors.whiteColor,
  fontSize: 15,
  textTransform: 'capitalize'
}

// Hover lightens the button edge to edge, like the sample rows below it.
const sx = {
  borderRadius: 0,
  transition: 'background-color 0.15s',
  '&:hover': {
    backgroundColor: themeColors.whiteTransparent01
  }
}

const iconStyle = {
  fontSize: 20,
  color: themeColors.mintColor
}

const StyledIcon = () => <Icon style={iconStyle} className={'fas fa-plus'} />

const AddSampleButton = ({ t, openNewSampleForm }) => (
  <Button variant="text" style={style} sx={sx} startIcon={<StyledIcon />} fullWidth onClick={openNewSampleForm}>
    {t('Add new sample')}
  </Button>
)

export default withTranslator(AddSampleButton)
